/**
 * Front-end behavior for mea/team-grid: the bio dialog annotated
 * "POP UP STATE" on Figma node 2008-7963 (frame 2008:8032).
 *
 * render.php emits one dialog per block instance, because the team page
 * stacks one instance per member group. Each card carries its own data on the
 * trigger - name, role, and the dialog portrait URL (the member's modal
 * photo, falling back to the headshot) - plus the bio markup in a sibling
 * <template>, so opening a dialog needs no request.
 *
 *   <section class="mea-team-grid">
 *     <ul class="mea-team-grid__list">
 *       <li class="mea-team-grid__item">
 *         <article class="mea-team-grid__card"> ...
 *           <button class="mea-team-grid__trigger" aria-haspopup="dialog"
 *                   aria-controls="{modal-id}"
 *                   data-mea-team-name/-role/-photo>...</button>
 *         </article>
 *         <template class="mea-team-grid__bio-data">...</template>
 *       </li>
 *     </ul>
 *     <div class="mea-team-modal" id="{modal-id}" role="dialog" aria-modal="true" hidden>
 *       <div class="mea-team-modal__scrim" data-mea-team-close></div>
 *       <div class="mea-team-modal__panel">...</div>
 *     </div>
 *   </section>
 *
 * Dialog behavior follows the WAI-ARIA APG "Dialog (Modal)" pattern: focus
 * moves into the dialog on open and is trapped there, Escape and the scrim
 * both close it, and focus returns to the card that opened it.
 */
( function () {
	const FOCUSABLE = [
		'a[href]',
		'button:not([disabled])',
		'[tabindex]:not([tabindex="-1"])',
	].join( ',' );

	function initTeamGrid( root ) {
		const modal = root.querySelector( '.mea-team-modal' );
		const triggers = Array.prototype.slice.call(
			root.querySelectorAll( '.mea-team-grid__trigger' )
		);
		if ( ! modal || ! triggers.length ) {
			return;
		}

		const photoWrap = modal.querySelector( '.mea-team-modal__photo-wrap' );
		const photo = modal.querySelector( '.mea-team-modal__photo' );
		const name = modal.querySelector( '.mea-team-modal__name' );
		const role = modal.querySelector( '.mea-team-modal__role' );
		const bio = modal.querySelector( '.mea-team-modal__bio' );
		const closeButton = modal.querySelector( '.mea-team-modal__close' );

		let lastTrigger = null;

		function focusable() {
			return Array.prototype.slice
				.call( modal.querySelectorAll( FOCUSABLE ) )
				.filter( function ( el ) {
					return el.offsetParent !== null;
				} );
		}

		function open( trigger ) {
			const item = trigger.closest( '.mea-team-grid__item' );
			const template = item
				? item.querySelector( '.mea-team-grid__bio-data' )
				: null;
			const photoUrl = trigger.dataset.meaTeamPhoto || '';
			const roleText = trigger.dataset.meaTeamRole || '';

			name.textContent = trigger.dataset.meaTeamName || '';

			role.textContent = roleText;
			role.hidden = roleText === '';

			if ( photoUrl ) {
				photo.src = photoUrl;
				photo.alt = name.textContent;
			} else {
				photo.removeAttribute( 'src' );
				photo.alt = '';
			}
			photoWrap.hidden = photoUrl === '';

			bio.innerHTML = '';
			if ( template && template.content ) {
				bio.appendChild( template.content.cloneNode( true ) );
			}

			lastTrigger = trigger;
			modal.hidden = false;
			document.body.style.overflow = 'hidden';
			closeButton.focus();
		}

		function close() {
			if ( modal.hidden ) {
				return;
			}
			modal.hidden = true;
			document.body.style.overflow = '';
			if ( lastTrigger ) {
				lastTrigger.focus();
				lastTrigger = null;
			}
		}

		// Keep Tab inside the dialog while it is open (APG focus trap).
		function trapTab( event ) {
			const items = focusable();
			if ( ! items.length ) {
				event.preventDefault();
				return;
			}
			const first = items[ 0 ];
			const last = items[ items.length - 1 ];

			const active = modal.ownerDocument.activeElement;

			if ( event.shiftKey && active === first ) {
				event.preventDefault();
				last.focus();
			} else if ( ! event.shiftKey && active === last ) {
				event.preventDefault();
				first.focus();
			}
		}

		triggers.forEach( function ( trigger ) {
			trigger.addEventListener( 'click', function () {
				open( trigger );
			} );
		} );

		modal
			.querySelectorAll( '[data-mea-team-close]' )
			.forEach( function ( el ) {
				el.addEventListener( 'click', close );
			} );

		modal.addEventListener( 'keydown', function ( event ) {
			if ( event.key === 'Tab' ) {
				trapTab( event );
			}
		} );

		document.addEventListener( 'keydown', function ( event ) {
			if ( event.key === 'Escape' && ! modal.hidden ) {
				close();
			}
		} );
	}

	function boot() {
		document.querySelectorAll( '.mea-team-grid' ).forEach( initTeamGrid );
	}

	if ( document.readyState !== 'loading' ) {
		boot();
	} else {
		document.addEventListener( 'DOMContentLoaded', boot );
	}
} )();
